const actionTypes = {
  GET_ACADEMIC_YEAR: 'getAcacemicYear',
  GET_MONTH: 'getMonth',
  GET_SERVICE_LOCATIONS: 'getServiceLocations',
  GET_SPECIALIST: 'getSpecialist',
  GET_ACTIVITY: 'getActivity',
  GET_CENTER: 'getCenter',
  GET_SEARCH_CONSULTING: 'getSearchConsulting',
  GET_PROVIDER: 'getProvider',
  GET_FINALIZED_BILLING_STATUS: 'getFinalizedBillingStatus',
};

export default actionTypes;
